import { useNavigate } from 'react-router-dom';

export default function NotFound({ isDetail }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(isDetail ? '/ventas' : '/');
  };

  return (
    <div
      className="mt-32 h-screen flex flex-col items-center justify-center h-full text-center pb-20"
      style={{ height: 'calc(100vh - 8rem)' }}
    >
      <img src="/notFound.png" alt="Not found page" className="h-96 w-96" />
      <p className="text-lg text-customBlue font-bold tracking-tight">
        {!isDetail
          ? 'La página solicitada no se encuentra disponible'
          : 'El Inmueble al que desea ingresar no se encuentra disponible o no existe'}
      </p>
      {!isDetail ? (
        <div className=" flex justify-center">
          <button
            onClick={handleClick}
            className="my-8 relative transition-all ease-in-out duration-300 shadow-[0px_10px_20px_rgba(0,0,0,0.2)] py-2 px-14 bg-[rgb(0,107,179)] rounded-full flex items-center justify-center cursor-pointer text-white gap-2 font-bold border-3 border-[#ffffff4d] outline-none overflow-hidden text-[15px] hover:scale-105 hover:border-[#fff9] before:absolute before:top-0 before:left-[-100px] before:w-[100px] before:h-full before:bg-gradient-to-r before:from-transparent before:via-white/80 before:to-transparent before:opacity-60 hover:before:animate-shine"
          >
            <svg
              viewBox="0 0 1024 1024"
              className="h-8 w-8 mr-1"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M496 124.608L96 524.576V1024h832V556.576z"
                  fill="#EAEAEA"
                ></path>
                <path d="M256 672h224v352H256z" fill="#434854"></path>
                <path
                  d="M544 640h96v96h-96zM672 640h96v96h-96zM672 512h96v96h-96zM544 512h96v96h-96z"
                  fill="#469FCC"
                ></path>
                <path
                  d="M544 512h96v32h-96zM672 512h96v32h-96zM544 640h96v32h-96zM672 640h96v32h-96z"
                  fill=""
                ></path>
                <path d="M496 64L96 480v96L496 176 928 608v-96z" fill=""></path>
                <path
                  d="M1012.576 505.376L541.248 34.048l-22.624-22.624a31.968 31.968 0 0 0-45.248 0l-22.624 22.624L11.424 473.376a31.968 31.968 0 0 0 0 45.248l22.624 22.624a31.968 31.968 0 0 0 45.248 0L496 124.608l448.672 448.672a31.968 31.968 0 0 0 45.248 0l22.624-22.624a32.032 32.032 0 0 0 0.032-45.28z"
                  fill="#EF4D4D"
                ></path>
                <path
                  d="M238.24 1024A126.656 126.656 0 0 0 256 960a128 128 0 0 0-256 0c0 23.424 6.752 45.088 17.76 64h220.48zM896 832a127.744 127.744 0 0 0-116.224 75.04A94.848 94.848 0 0 0 736 896a96 96 0 0 0-96 96c0 11.296 2.304 21.952 5.888 32h360.384A126.944 126.944 0 0 0 1024 960a128 128 0 0 0-128-128z"
                  fill="#3AAD73"
                ></path>
                <path
                  d="M779.776 907.04A94.848 94.848 0 0 0 736 896a96 96 0 0 0-96 96c0 11.296 2.304 21.952 5.888 32h139.872A126.656 126.656 0 0 1 768 960c0-18.944 4.384-36.768 11.776-52.96z"
                  fill=""
                ></path>
              </g>
            </svg>
            Ir a inicio
          </button>
        </div>
      ) : (
        <div className=" flex justify-center">
          <button
            onClick={handleClick}
            className="my-8 relative transition-all ease-in-out duration-300 shadow-[0px_10px_20px_rgba(0,0,0,0.2)] py-2 px-14 bg-[rgb(0,107,179)] rounded-full flex items-center justify-center cursor-pointer text-white gap-2 font-bold border-3 border-[#ffffff4d] outline-none overflow-hidden text-[15px] hover:scale-105 hover:border-[#fff9] before:absolute before:top-0 before:left-[-100px] before:w-[100px] before:h-full before:bg-gradient-to-r before:from-transparent before:via-white/80 before:to-transparent before:opacity-60 hover:before:animate-shine"
          >
            <svg
              className="h-8 w-8 mr-1"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 503.467 503.467"
              xmlSpace="preserve"
              fill="#000000"
              transform="rotate(0)matrix(-1, 0, 0, 1, 0, 0)"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <g transform="translate(1 1)">
                  <path
                    style={{ fill: '#FF7474' }}
                    d="M361.667,199.533c0-89.6-72.533-162.133-162.133-162.133S37.4,109.933,37.4,199.533 s72.533,162.133,162.133,162.133S361.667,289.133,361.667,199.533 M395.8,199.533c0,8.533-0.853,17.067-1.707,25.6 c-4.267,32.427-16.213,62.293-34.133,87.893c-12.8,18.773-29.013,34.987-47.787,47.787c-31.573,22.187-70.827,35.84-112.64,35.84 C91.16,396.653,3.267,308.76,3.267,200.387S91.16,4.12,199.533,4.12c82.773,0,153.6,51.2,182.613,123.733 C390.68,149.187,395.8,173.933,395.8,199.533"
                  ></path>
                  <path
                    style={{ fill: '#AAB1BA' }}
                    d="M428.227,380.44l-47.787,47.787l-0.853,0.853l-66.56-66.56l-0.853-1.707 c18.773-12.8,34.987-29.013,47.787-47.787l1.707,0.853L428.227,380.44z"
                  ></path>
                  <path
                    style={{ fill: '#80D6FA' }}
                    d="M487.96,440.173c13.653,13.653,13.653,34.987,0,48.64s-34.987,13.653-48.64,0l-59.733-59.733 l0.853-0.853l47.787-47.787l0,0L487.96,440.173z"
                  ></path>
                  <path
                    style={{ fill: '#FFD0A1' }}
                    d="M481.133,182.467v93.867h-51.2v-51.2h-33.28h-2.56c0.853-8.533,1.707-17.067,1.707-25.6 c0-25.6-5.12-50.347-13.653-72.533l1.707-0.853l20.48-20.48L481.133,182.467z"
                  ></path>
                  <path
                    style={{ fill: '#ECF4F7' }}
                    d="M199.533,37.4c89.6,0,162.133,72.533,162.133,162.133s-72.533,162.133-162.133,162.133 S37.4,289.133,37.4,199.533S109.933,37.4,199.533,37.4L199.533,37.4z M276.333,182.467l-76.8-76.8l-76.8,76.8v93.867h59.733v-51.2 H216.6v51.2h59.733V182.467z"
                  ></path>
                  <polygon
                    style={{ fill: '#FFD0A1' }}
                    points="276.333,182.467 276.333,276.333 216.6,276.333 216.6,225.133 182.467,225.133 182.467,276.333 122.733,276.333 122.733,182.467 199.533,105.667"
                  ></polygon>
                </g>
                <path
                  style={{ fill: '#51565F' }}
                  d="M465.067,503.467c-10.24,0-19.627-4.267-27.307-11.093L337.067,390.827 c-1.707-1.707-1.707-4.267,0-5.973c1.707-1.707,4.267-1.707,5.973,0L443.733,486.4c5.973,5.973,12.8,8.533,21.333,8.533l0,0 c7.68,0,15.36-3.413,21.333-8.533c5.973-5.973,8.533-12.8,8.533-21.333c0-8.533-3.413-15.36-8.533-21.333l-57.173-57.173 l-21.333,21.333c-1.707,1.707-4.267,1.707-5.973,0c-1.707-1.707-1.707-4.267,0-5.973l23.893-23.893 c0.853-0.853,1.707-0.853,3.413-0.853l0,0c0.853,0,2.56,0.853,3.413,0.853l59.733,59.733c7.68,6.827,11.093,17.067,11.093,27.307 c0,10.24-4.267,19.627-11.093,27.307C484.693,499.2,475.307,503.467,465.067,503.467L465.067,503.467z M200.533,401.067 C89.6,401.067,0,311.467,0,200.533S89.6,0,200.533,0s200.533,89.6,200.533,200.533S311.467,401.067,200.533,401.067z M200.533,8.533 c-105.813,0-192,86.187-192,192s86.187,192,192,192s192-86.187,192-192S306.347,8.533,200.533,8.533z M200.533,366.933 c-92.16,0-166.4-74.24-166.4-166.4s74.24-166.4,166.4-166.4c92.16,0,166.4,74.24,166.4,166.4S292.693,366.933,200.533,366.933z M200.533,42.667c-87.04,0-157.867,70.827-157.867,157.867S113.493,358.4,200.533,358.4S358.4,287.573,358.4,200.533 S287.573,42.667,200.533,42.667z M406.187,361.813c-0.853,0-2.56,0-3.413-0.853l-17.92-17.92C384,342.186,384,341.333,384,339.627 s0-2.56,0.853-3.413c1.707-1.707,4.267-1.707,5.973,0l17.92,17.92c0.853,0.853,0.853,1.707,0.853,3.413s0,2.56-0.853,3.413 C407.893,361.813,407.04,361.813,406.187,361.813z M482.133,281.6h-51.2c-2.56,0-4.267-1.707-4.267-4.267v-51.2 c0-2.56,1.707-4.267,4.267-4.267h28.16v-38.4c0-1.707,1.707-3.413,2.56-4.267c1.707-0.853,4.267-0.853,5.12,0l29.013,29.013 c0.853,0.853,0.853,1.707,0.853,2.56v66.56C486.4,280.747,484.693,281.6,482.133,281.6L482.133,281.6z M435.2,273.067h42.667 v-60.16l-24.747-24.747v34.987c0,2.56-1.707,4.267-4.267,4.267h-38.4V273.067z M268.8,281.6h-59.733c-2.56,0-4.267-1.707-4.267-4.267 v-46.933h-25.6v46.933c0,2.56-1.707,4.267-4.267,4.267H122.8c-2.56,0-4.267-1.707-4.267-4.267V182.467c0-1.707,0.853-2.56,1.707-3.413 l76.8-76.8c1.707-1.707,4.267-1.707,5.973,0l76.8,76.8c0.853,0.853,1.707,1.707,1.707,3.413v93.867 C272.213,279.893,270.507,281.6,268.8,281.6z M213.067,273.067h51.2v-89.6l-72.533-72.533l-72.533,72.533v89.6h51.2v-46.933 c0-2.56,1.707-4.267,4.267-4.267h33.28c2.56,0,4.267,1.707,4.267,4.267V273.067z"
                ></path>
              </g>
            </svg>
            Buscar otra opción de inmueble
          </button>
        </div>
      )}
    </div>
  );
}
